import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `MergeContentRoot`,
  grid: `MergeContentGrid`
};

export function useMergeContentStyles() {
  const { effects, spacing } = useTheme();

  const styles = useMemo(
    () => mergeStyleSets({
      root: [classNames.root, { height: `100%` }],
      grid: [
        classNames.grid,
        {
          boxShadow: effects.elevation8,
          padding: `15px`
        }
      ]
    }),
    [effects]
  );

  const mergeStyles = useMemo(
    () => mergeStyleSets({
      footer: [
        {
          padding: `${spacing.s1} 0 0 0`,
          margin: 0,
          [`& > .MergeOrigin`]: {
            padding: `0 0 0 75px`
          },
          [`& > .MergeTarget`]: {
            padding: `0 0 0 20px`
          }
        }
      ]
    }),
    [spacing]
  );

  return {
    styles,
    mergeStyles
  };
}
